import { Button, Drawer, IconButton, MenuItem, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';
// import { usepalletActions } from 'src/context/providers/palletContext';
import CloseIcon from '@mui/icons-material/Close';
import { usePalletActions } from 'src/context/providers/PalleteContext';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { useSettingsContext } from 'src/components/settings';
import { GZAVNILI_MODES } from 'src/components/settings/drawer/gzavnili-mode';
import InputFieds from '../../custom_components/Froms/InputFields';
import { status, personalInformation } from './view/data';
import { DirectionSelect } from '../orderPhysical/direction-picker-modal';

const CreatepalletDrawer = ({ isDrawerOpen, handleDrawerToggle }) => {
  const [palletData, setpalletData] = useState({
    tracking: '',
    status: '',
    // airwayBill: '',
  });

  const { createPallet, createPhysicalPallet } = usePalletActions();
  const { gzavniliMode } = useSettingsContext();
  const isPhysical = gzavniliMode === GZAVNILI_MODES.physical;
  const [direction, setDirection] = useState('');

  const Clear = () => {
    setpalletData({});
    setDirection('');
  };

  const handleCreatepallet = async () => {
    const palletData1 = {
      tracking: palletData.tracking,
      status: palletData.status,
      // airwaybill_id: palletData.airwayBill,
    };
    if (isPhysical) {
      if (!direction) {
        toast.error('Choose a direction for the pallet');
        return;
      }
      const created = await createPhysicalPallet({ ...palletData1, direction });
      if (!created) return;
    } else {
      await createPallet(palletData1);
    }
    Clear();
    handleDrawerToggle();
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setpalletData({
      ...palletData,
      [name]: value,
    });
  };
  // const airwayBills = useAirwayBillData();

  const DrawerConfig = {
    SubNavigation: true,
    anchor: 'right',
    width: '40%',
    drawerHeaderText: 'Create pallet',
    buttons: {
      status: true,
      elements: [{ name: 'Create', onClick: handleCreatepallet }],
    },
  };

  const containerStyle = {
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    position: 'fixed',
    zIndex: 2,
    top: 0,
    left: 0,
    display: isDrawerOpen ? 'block' : 'none',
    cursor: 'pointer',
  };

  const handleOutsideClick = (event) => {
    if (event.target === event.currentTarget) {
      handleDrawerToggle();
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      style={containerStyle}
      onKeyDown={(event) => {
        if (event.key === 'Escape') {
          handleDrawerToggle();
        }
      }}
      onClick={handleOutsideClick}
    >
      <Drawer
        variant="persistent"
        anchor={DrawerConfig.anchor}
        open={isDrawerOpen}
        onClose={handleDrawerToggle}
        PaperProps={{
          sx: { width: { lg: DrawerConfig.width, xs: '100%', md: '100%' } },
        }}
      >
        {/* Drawer Content */}

        {/* Header */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px',
            borderBottom: '1px solid rgba(220, 220, 220, 0.2)',
          }}
        >
          <Typography variant="h6">{DrawerConfig.drawerHeaderText}</Typography>
          <div
            style={{
              width: '30%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <TextField
              name="status"
              label="status"
              value={palletData[status]}
              onChange={handleInputChange}
              variant="filled"
              sx={{ minWidth: '80%' }}
              select
            >
              {status.map((i, index) => (
                <MenuItem key={index} value={i}>
                  {i}
                </MenuItem>
              ))}
            </TextField>

            <IconButton onClick={handleDrawerToggle}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>

        {/* Form */}
        <div
          className="content-wrap"
          style={{
            gap: '2px',
            padding: '30px 0px 0px 0px',
            alignItems: 'center',
            justifyContent: 'space-evenly',
          }}
        >
          {/* Form */}

          {/* Personal Information */}
          <InputFieds
            userData={palletData}
            heading="Pallet Information"
            inputFields={personalInformation}
            setUserData={setpalletData}
          />
          {/* Personal Information */}
          {isPhysical && (
            <DirectionSelect
              value={direction}
              onChange={setDirection}
              sx={{ width: '95%', ml: '20px', mt: 2 }}
            />
          )}
          {/* <div
            className="content-wrap"
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              padding: '0px 0px 0px 20px',
            }}
          >
            <SelectFieldForOrder
              key="airwayBill"
              widthComp="95%"
              selectName="airwayBill"
              data={airwayBills}
              setter={handleInputChange}
              selectedValue={palletData.airwayBill}
              optionName="tracking"
            />
          </div> */}
        </div>

        {/* Buttons */}
        {DrawerConfig.buttons && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              borderTop: '1px solid rgba(220, 220, 220, 0.2)',
              padding: '16px',
              position: 'absolute',
              bottom: '0',
              left: '0',
              width: '100%',
            }}
          >
            {DrawerConfig.buttons.elements.map((element, index) => (
              <Button
                key={index}
                variant="contained"
                style={{
                  marginLeft: '24px',
                  width: '136px',
                }}
                onClick={element.onClick}
              >
                Create
              </Button>
            ))}
          </div>
        )}
      </Drawer>
    </div>
  );
};

CreatepalletDrawer.propTypes = {
  isDrawerOpen: PropTypes.bool.isRequired,
  handleDrawerToggle: PropTypes.func.isRequired,
};

export default CreatepalletDrawer;
